import React, { useState, useEffect } from 'react';
import "./About.scss";
import { motion } from "framer-motion";
//import images from "../../assets/imageExport";
import { client, urlFor } from "../../sanity_client/client";
import AppWrap from '../../Wrapper/AppWrap';

const About = () => {

    const [ abouts, setAbouts ] = useState([])

    useEffect(()=>{
        // Fetch about section
        const q = '*[_type == "abouts"]';
        client.fetch(q)
            .then((data)=>{setAbouts(data)})
    },[])
    return (
        <div className="about__section">
            <h2 className="head-text">
                <span>Code </span> artisan
                <br/>
                at <span>your </span> service
            </h2>

            <div className="app__profiles">
                {/* loop over about section */}
                {abouts.map((ab, index)=>(
                    <motion.div className="app_profiles-item"
                        whileInView={{
                            opacity: [0, 1],
                            y:[100, 0],
                            transition:{duration: 0.6},
                            scale:[0.95, 1]
                        }}
                        whileHover={{
                                scale:1.3,
                                // borderWidth: 2,
                                // borderStyle: 'solid',
                                // borderColor: '#6b7688',
                                //backgroundColor: 'white',
                                // borderRadius:"10%", 
                                // padding:10,
                                transition:{
                                    duration: 0.2, 
                                    type: "spring", 
                                    stiffness: 100
                                } 
                        }}
                        key={ab.title + index}
                    >
                        <img src={urlFor(ab.imgUrl)} alt={ab.title}/>
                        <h2 className="bold-text" style={{marginTop:20}}>{ab.title}</h2>
                        <p className="p-text" style={{marginTop:10}}>{ab.description}</p>

                    </motion.div>
                ))}
            </div>
        </div>
    )
}

export default AppWrap(About, "about",)